import React, { useState } from 'react'
import { MessageCardStack } from '@pandiafi/components'
import { Button } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { MessageThread } from '../../../common/validations/residentMessageTimelineSchema'
import { MessageThreadCard } from './MessageThreadCard'
import { getLatestMessage } from '../../utils/newMessage'

export const ThreadStack = ({
  thread,
  onViewThread,
  open,
  header,
}: {
  thread: MessageThread
  onViewThread: ((id: string) => void) | null
  open: boolean
  header?: React.ReactNode
}) => {
  const { t } = useTranslation(['messages'])
  const { entries } = thread
  const [showAll, setShowAll] = useState(false)

  const first = entries[0]
  const latestMessage = getLatestMessage(entries)
  if (!first || !latestMessage) {
    return null
  }

  const renderMessage = (
    msg: MessageThread['entries'][number],
    messageHeader?: React.ReactNode
  ) => (
    <MessageThreadCard
      key={`msg-${msg.messageId}`}
      msg={msg}
      latestMessageId={latestMessage.messageId}
      threadId={thread.id}
      onViewThread={onViewThread}
      contentHeight={open ? undefined : 'short'}
      header={messageHeader}
      categoryName={thread.messageCategory?.nameFi}
    />
  )

  if (!showAll && open) {
    return (
      <>
        {renderMessage(first, header)}
        {entries.length > 1 && (
          <div className="flex justify-center">
            <Button
              variant="pill"
              small
              icon="plus"
              onClick={() => setShowAll(true)}
            >
              {t('messages:view.showConversation')} ({entries.length - 1})
            </Button>
          </div>
        )}
      </>
    )
  }

  if (showAll && open) {
    return (
      <>
        {entries.map((msg) =>
          renderMessage(
            msg,
            msg.messageId === first.messageId ? header : undefined
          )
        )}
        <div className="flex justify-center">
          <Button
            variant="pill"
            small
            icon="minus"
            onClick={() => setShowAll(false)}
          >
            {t('messages:view.hideConversation')}
          </Button>
        </div>
      </>
    )
  }

  return entries.length > 1 ? (
    <MessageCardStack
      stackDirection="down"
      stackAmount={entries.length}
      contentHeight="short"
      stackCards={entries
        .slice(1)
        .map((msg) =>
          msg.__typename === 'IncomingEmailMessage' ? 'sent' : 'received'
        )}
    >
      {renderMessage(first, header)}
    </MessageCardStack>
  ) : (
    renderMessage(first, header)
  )
}
